/** First usable image URL for catalog thumbnails (matches Product detail page logic). */
export type ProductImageSource = {
  thumbnailUrl?: string | null;
  imageUrl?: string | null;
  media?: Array<{ url: string; mediaType: string }> | null;
};

export function primaryProductImageUrl(product: ProductImageSource | null | undefined): string | null {
  if (!product) return null;
  const primary = product.imageUrl?.trim();
  if (primary) return primary;
  const images = product.media?.filter((m) => m.mediaType === 'IMAGE') ?? product.media ?? [];
  return images[0]?.url?.trim() || null;
}

/** Prefer API-resolved list thumbnail, else primaryProductImageUrl. */
export function productThumbnailUrl(product: ProductImageSource | null | undefined): string | null {
  if (!product) return null;
  const thumb = product.thumbnailUrl?.trim();
  if (thumb) return thumb;
  return primaryProductImageUrl(product);
}
